<template>
  <div>
    <el-dialog
      title="Ödeme İşle"
      :visible="OdemeIsleModal"
      center
      width="50%">
      <a @click="ModalKapat" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form v-if="Form" :rules="FormHata" :model="Form"
               @submit.prevent.native="Submit"
               ref="Form">
        <el-row :gutter="24">
          <Yukleniyor :data="lo"></Yukleniyor>
          <el-col :span="24" v-if="BankaEkstre">
            <div v-if="BankaEkstre" class="VezneBankaOlayi">
              <img :src="'https://pos.mudu.pro/oi/banka/'+BankaEkstre.Banka+'.png'" width="100">
              <span><sup>Dekont Tutarı</sup> <b>{{BankaEkstre.TutarText}}<sup>TL</sup></b></span>
            </div>
          </el-col>
          <el-col :span="6" v-if="BankaEkstre">
            <el-form-item label="Site / Bina" prop="Bina_id">
              <el-select @change="BinaSecimi()" v-model="Form.Bina_id" filterable>
                <el-option-group
                  label="Site Listesi">
                  <el-option
                    v-for="item in Siteler"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  label="Bina Listesi">
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="BankaEkstre?6:12">
            <el-form-item label="Kasa" prop="Kasa_id">
              <el-cascader
                :props="{ multiple: false}"
                :options="Kasalar"
                v-model="Form.Kasa_id"
                collapse-tags
                filterable></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Tutar" prop="Tutar">
              <el-input v-model="Form.Tutar"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Ödeme Tarihi" prop="oTarihi">
              <el-date-picker
                v-model="Form.oTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input v-model="Form.Aciklama"/>
            </el-form-item>
          </el-col>

          <!--el-col :span="24">
            <el-form-item class="text-center" label="Ödeme Türü" prop="oTarihi">
              <el-radio-group v-model="Form.Tur" size="mini">
                <el-radio-button :label="3">Yapılan Ödeme</el-radio-button>
                <el-radio-button :label="4">Alınan Ödeme</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col-->


        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="!lo" size="medium" @click="Submit()" icon="el-icon-check">
          Ödeme İşle
        </el-button>
      </div>
    </el-dialog>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>

  </div>
</template>
<script>
  import MakbuzDetay from "../../Vezne/MakbuzDetay";
  import Yukleniyor from "../../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, MakbuzDetay},
    props: ["OdemeIsleModal", "Cari_id", "Bina_id", "BankaEkstre"],
    data() {
      return {
        lo: false,
        mNo: null,
        Kasalar: [],
        Binalar: [],
        Siteler: [],
        MakbuzDetayModal: false,
        Form: {
          Kasa_id: null,
          Cari_id: this.Cari_id,
          Bina_id: this.Bina_id,
          Tutar: 0,
          oTarihi: null,
          Aciklama: null,
          Banka_Dokum_id: null,
          Tur: 3
        },
        FormHata: {
          Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          oTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {
      ModalKapat() {
        this.$emit('OdemeIsleModal', false);
        this.OdemeIsleModal = false

      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/odeme'})
              .then(response => {
                this.lo = false;
                //console.log(response);
                if (response.Durum == "OK") {
                  this.mNo = response.mNo;
                  this.$confirm(response.Mesaj, 'Başarılı', {
                    confirmButtonText: 'Belge Yazdır',
                    cancelButtonText: 'İşleme Devam Et',
                    type: 'success'
                  }).then(() => {
                    this.$emit('mNo', response.mNo);
                    this.MakbuzDetayModal = true
                  }).catch(() => {
                    this.$emit('OdemeIsleModal', false);
                  });
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })
      },
      BinaSecimi() {
        this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.Form.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kasalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }

    },
    created() {

      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
        this.BinaSecimi()
      }
      var Gun = new Date();
      this.Form.oTarihi = Gun;
      if (this.BankaEkstre) {
        this.Form.Banka_Dokum_id = this.BankaEkstre.id;
        this.$store.dispatch("Get", {path: 'yonetim/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'yonetim/site'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Siteler = response.Liste
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });


        this.Form.Aciklama = this.BankaEkstre.Aciklama;
        this.Form.Tutar = this.BankaEkstre.Kalan
      }
    }

  }
</script>

<style scoped>
  .VezneBankaOlayi {
    padding: 0 10px;
    border-bottom: 1px solid #dcdee5;
    margin-bottom: 10px;
  }

  .VezneBankaOlayi img {
  }

  .VezneBankaOlayi span {
    float: right;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Muhasebe/cari/OdemeIsle.vue